import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";

// @mui material components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import {
  getProfile,
  getUserList,
  updateUser,
  createNewUser,
} from "actions/userActions";

import MDActionConfigurator from "components/MDActionConfigurator";

const UserManagement = () => {
  const configuratorRef = useRef(null);
  const dispatch = useDispatch();
  const [currentState, setCurrentState] = useState("");
  const [currentData, setCurrentData] = useState({
    _id: "",
    name: "",
    email: "",
    phone: "",
    idNumber: "",
    role: "user",
    image: "",
  });

  const getMe = useSelector((state) => state.getMe);
  const { me } = getMe;
  console.log("🚀 ~ file: index.js:44 ~ UserManagement ~ me:", me);

  useEffect(() => {
    // if (me?.length === 0) {
    dispatch(getProfile());
    // }
  }, [dispatch]);

  const listUsers = useSelector((state) => state.listUsers);
  const { usersList } = listUsers;

  useEffect(() => {
    if (usersList?.length === 0) {
      dispatch(getUserList());
    }
  }, [dispatch, usersList?.length]);

  const handleToggleBackdrop = (item, state) => {
    setCurrentData(item);
    setCurrentState(state);
    if (configuratorRef.current) {
      configuratorRef.current.handleToggleConfigurator();
    }
  };

  const roleOptions = [
    {
      name: "Super Admin",
      value: "super_admin",
    },
    {
      name: "Admin",
      value: "admin",
    },
    {
      name: "Agent",
      value: "agent",
    },
    {
      name: "User",
      value: "user",
    },
  ];

  const handleSubmitUser = (e) => {
    if (currentState === "edit") {
      dispatch(updateUser(currentData?._id, e));
    } else {
      const myData = {
        data: {
          type: "users",
          attributes: e,
          relationships: {
            roles: {
              data: [
                {
                  type: "roles",
                  id: "1",
                },
              ],
            },
          },
        },
      };
      dispatch(createNewUser(myData));
    }
    handleToggleBackdrop({}, "");
  };

  const Author = ({ image, name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDAvatar src={image} name={name} size="sm" />
      <MDBox ml={2} lineHeight={1}>
        <MDTypography
          display="block"
          variant="button"
          fontWeight="medium"
          sx={{
            color: ({ palette: { text } }) => text.darkAccent,
          }}
        >
          {name}
        </MDTypography>
        <MDTypography
          variant="caption"
          sx={{
            color: ({ palette: { text } }) => text.darkAccent,
          }}
        >
          {email}
        </MDTypography>
      </MDBox>
    </MDBox>
  );

  const Job = ({ title, description }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography
        display="block"
        variant="caption"
        sx={{
          color: ({ palette: { text } }) => text.darkAccent,
        }}
        fontWeight="medium"
      >
        {title}
      </MDTypography>
      <MDTypography variant="caption">{description}</MDTypography>
    </MDBox>
  );

  function renderRows(data) {
    const values = [];
    data?.forEach((item, index) => {
      const newElement = {
        user: (
          <Link to={`/user-management/${item?._id}`}>
            <Author
              key={`user-${index}`}
              image={item?.profile_image}
              name={item?.name}
              email={item?.email}
            />
          </Link>
        ),
        role: <Job title={item.role} description="" />,
        phone: (
          <MDTypography
            variant="caption"
            sx={{
              color: ({ palette: { text } }) => text.darkAccent,
            }}
            fontWeight="medium"
          >
            {item.phone}
          </MDTypography>
        ),
        creation_date: (
          <MDTypography
            variant="caption"
            sx={{
              color: ({ palette: { text } }) => text.darkAccent,
            }}
            fontWeight="medium"
          >
            {moment(item.created_at).format("Do MMMM YYYY")}
          </MDTypography>
        ),
        state: (
          <>
            {item?.active ? (
              <Chip
                icon={<Icon sx={{ fontWeight: "bold" }}>person</Icon>}
                label="Active"
                variant="outlined"
                color="info"
                sx={{ paddingLeft: 1 }}
              />
            ) : (
              <Chip
                icon={<Icon sx={{ fontWeight: "bold" }}>person_off</Icon>}
                label="Inactive"
                color="error"
                sx={{ paddingLeft: 1 }}
              />
            )}
          </>
        ),
        verified: (
          <>
            {item?.email_verified_at ? (
              <Chip
                icon={<Icon sx={{ fontWeight: "bold" }}>verified</Icon>}
                label="Verified"
                variant="outlined"
                color="info"
                sx={{ paddingLeft: 1 }}
              />
            ) : (
              <Chip
                icon={<Icon sx={{ fontWeight: "bold" }}>update</Icon>}
                label="Awaiting Verification"
                color="error"
                sx={{ paddingLeft: 1 }}
              />
            )}
          </>
        ),
      };

      values.push(newElement);
    });
    return values;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox>
              {(me?.role === "super_admin" || me?.role === "admin") && (
                <MDBox p={2} mt="auto" display="flex" justifyContent="end">
                  <MDButton
                    component="a"
                    href="#"
                    rel="noreferrer"
                    variant="gradient"
                    color="light"
                    onClick={() =>
                      handleToggleBackdrop(
                        {
                          _id: "",
                          name: "",
                          email: "",
                          phone: "",
                          idNumber: "",
                          role: "user",
                          profile_image: "",
                        },
                        ""
                      )
                    }
                  >
                    <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                    &nbsp;New Admin User
                  </MDButton>
                </MDBox>
              )}
              <DataTable
                table={{
                  columns: [
                    {
                      Header: "Admin User",
                      accessor: "user",
                      width: "20%",
                      align: "left",
                    },
                    {
                      Header: "phone",
                      accessor: "phone",
                      width: "20%",
                      align: "left",
                    },
                    {
                      Header: "role",
                      accessor: "role",
                      width: "20%",
                      align: "left",
                    },
                    {
                      Header: "creation date",
                      accessor: "creation_date",
                      width: "20%",
                      align: "left",
                    },
                    {
                      Header: "verified",
                      accessor: "verified",
                      align: "center",
                    },
                    { Header: "state", accessor: "state", align: "center" },
                  ],
                  rows: renderRows(usersList),
                }}
                isSorted={true}
                entriesPerPage={false}
                showTotalEntries={true}
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>

      <MDActionConfigurator
        ref={configuratorRef}
        title="Admin User"
        onCompleteConfig={handleSubmitUser}
        data={[
          {
            keyType: "_id",
            valueType: currentData?._id,
          },
          {
            labelType: "Name",
            placeholderType: "Enter Name",
            dataType: "text",
            keyType: "name",
            valueType: currentData?.name,
          },
          {
            labelType: "Email",
            placeholderType: "Enter Email",
            dataType: "email",
            keyType: "email",
            valueType: currentData?.email,
          },
          {
            labelType: "Phone",
            placeholderType: "Enter Phone",
            dataType: "phone",
            keyType: "phone",
            valueType: currentData?.phone,
          },
          {
            labelType: "National ID Number",
            placeholderType: "Enter National ID Number",
            dataType: "text",
            keyType: "idNumber",
            valueType: currentData?.idNumber,
          },
          {
            labelType: "Role",
            placeholderType: "Choose Role",
            dataType: "select",
            keyType: "role",
            valueType: currentData?.role,
            options: roleOptions,
          },
          {
            labelType: "Profile Image",
            placeholderType: "Enter Profile Image",
            dataType: "image",
            keyType: "image",
            valueType: currentData?.profile_image,
          },
        ]}
        state={currentState}
      />
      <Footer />
    </DashboardLayout>
  );
};

export default UserManagement;
